export const LOGIN_TYPE = "auth/login";
export const SIGN_UP_TYPE = "auth/signup";
export const FETCH_PROFILE_TYPE = "user/profile";
export const SETUP_2FA_TYPE = "auth/setup-2fa";
export const FETCH_WALLET_TYPE = "wallet/fetch";
export const FETCH_TRANSACTIONS = "transactions";
export const FETCH_FAQS = "fetch/faqs";
export const FETCH_ADMIN_USERS = "fetch/admin/users";
export const FETCH_ADMIN_PROFILE = "fetch/admin/profile";
export const FETCH_ADMIN_TRANSACTIONS = "fetch/admin/transactions";
export const FETCH_ADMIN_WALLET = "fetch/admin/wallet";
export const FETCH_ADMIN_DASHBOARD_STATS = "fetch/admin/dashboard/stats";
export const ADMIN_LOGIN = "admin/login";
